import {faEdit, faPhoneFlip, faCalendar, faUsers} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Plus} from "lucide-react";
import React from "react";
function StatisticCard(){
    return(
        <div className="g-3 mb-3 row">
            <div className="col-xxl-4 col-xl-3 col-md-4 col-sm-6">
                <div className="h-100 card">
                    <div className="card-body">
                        <div className="d-flex d-sm-block justify-content-between">
                            <div className="border-bottom-sm mb-sm-4">
                                <div className="d-flex align-items-center">
                                    <div className="d-flex align-items-center icon-wrapper-sm shadow-primary-100"
                                         style={{transform: "rotate(-7.45deg)"}}>
                                        <FontAwesomeIcon icon={faUsers} className="text-primary fs-7 z-1 ms-2"/>
                                    </div>
                                    <p className="text-body-tertiary fs-9 mb-0 ms-2 mt-3">Total User Visitor</p></div>
                                <p className="text-primary mt-2 fs-6 fw-bold mb-0 mb-sm-4 text-center">3 <span
                                    className="fs-8 text-body lh-lg">Users</span></p></div>
                            <div
                                className="d-flex flex-column justify-content-center flex-between-end d-sm-block text-end text-sm-start">
                                <span className="fs-10 mb-2 badge-phoenix badge-phoenix-success badge">+24.5%</span><p
                                className="mb-0 fs-9 text-body-tertiary">Than yesterday</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xxl-4 col-xl-3 col-md-4 col-sm-6">
                <div className="h-100 card">
                    <div className="card-body">
                        <div className="d-flex d-sm-block justify-content-between">
                            <div className="border-bottom-sm mb-sm-4">
                                <div className="d-flex align-items-center">
                                    <div className="d-flex align-items-center icon-wrapper-sm shadow-primary-100"
                                         style={{transform: "rotate(-7.45deg)"}}>
                                        <FontAwesomeIcon icon={faCalendar} className="text-info fs-7 z-1 ms-2"/>
                                    </div>
                                    <p className="text-body-tertiary fs-9 mb-0 ms-2 mt-3">Total User Use App</p></div>
                                <p className="text-primary mt-2 fs-6 fw-bold mb-0 mb-sm-4">3 <span
                                    className="fs-8 text-body lh-lg">Leads Today</span></p></div>
                            <div
                                className="d-flex flex-column justify-content-center flex-between-end d-sm-block text-end text-sm-start">
                                <span className="fs-10 mb-2 badge-phoenix badge-phoenix-success badge">+24.5%</span><p
                                className="mb-0 fs-9 text-body-tertiary">Than yesterday</p></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xxl-4 col-xl-6 col-md-4">
                <div className="border-bottom"><h5 className="pb-4 border-bottom">Top 5 User Chat Daily</h5>
                    <div className="list-group list-group-flush">
                        <div className="bg-transparent list-group-crm fw-bold text-body fs-9 py-2 list-group-item">
                            <div className="d-flex justify-content-between"><span className="fw-normal fs-9 mx-1"><span
                                className="fw-bold">1.</span> None</span> <span>(65)</span></div>
                        </div>
                        <div className="bg-transparent list-group-crm fw-bold text-body fs-9 py-2 list-group-item">
                            <div className="d-flex justify-content-between"><span className="fw-normal fs-9 mx-1"><span
                                className="fw-bold">2.</span> Online Store</span> <span>(74)</span></div>
                        </div>
                        <div className="bg-transparent list-group-crm fw-bold text-body fs-9 py-2 list-group-item">
                            <div className="d-flex justify-content-between"><span className="fw-normal fs-9 mx-1"><span
                                className="fw-bold">3.</span> Advertisement</span> <span>(32)</span></div>
                        </div>
                        <div className="bg-transparent list-group-crm fw-bold text-body fs-9 py-2 list-group-item">
                            <div className="d-flex justify-content-between"><span className="fw-normal fs-9 mx-1"><span
                                className="fw-bold">4.</span> Seminar Partner</span> <span>(25)</span></div>
                        </div>
                        <div className="bg-transparent list-group-crm fw-bold text-body fs-9 py-2 list-group-item">
                            <div className="d-flex justify-content-between"><span className="fw-normal fs-9 mx-1"><span
                                className="fw-bold">5.</span> Partner</span> <span>(23)</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatisticCard;